import cn from 'classnames';
import Button from 'components/Button';
import FormattedText from 'components/FormattedText';
import { i18nPath } from 'config/i18nNs';
import { Col, Row } from 'layout/Grid';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Body1, Heading1, Heading2 } from 'typography';
import { getPoliciesLink } from 'utils/versionUtils';
import styles from './home.module.scss';

export interface HomepageProps {
  excom: boolean;
}

const Homepage: React.FC<HomepageProps> = ({ excom }) => {
  const { t } = useTranslation(['homepage', 'dictionary']);

  const goToPolicies = (
    market: string,
    lang: string,
    version: 'global' | 'excom'
  ) => {
    const newLocation = getPoliciesLink(market, lang, version);
    window.location.href = excom ? `${newLocation}&ex=true` : newLocation;
  };

  return (
    <>
      <Row className={styles.intro} columnGap={45} mobileColumnGap={16}>
        <Col sm={12}>
          <div className={styles.title}>
            <Heading1>
              {excom
                ? t(`${i18nPath.homepage}.home.exComTitle`)
                : t(`${i18nPath.homepage}.home.title`)}
            </Heading1>
          </div>

          <FormattedText i18nKey={`${i18nPath.homepage}.home.intro`} />
        </Col>
      </Row>

      <Row
        className={styles.options}
        rowGap={45}
        columnGap={45}
        mobileColumnGap={16}
      >
        <Col sm={12} md={6} className={cn('column', styles.block)}>
          <div className={styles.title}>
            <Heading2>{t(`${i18nPath.homepage}.global.title`)}</Heading2>
          </div>
          <Body1>{t(`${i18nPath.homepage}.global.intro`)}</Body1>
          <div className={styles.button}>
            <Button
              variant="secondary"
              onClick={() => goToPolicies('dk', 'en', 'global')}
            >
              {t(`${i18nPath.dictionary}.knowMore`, 'Know more')}
            </Button>
          </div>
        </Col>
        <Col sm={12} md={6} className={cn('column', styles.block)}>
          <Heading2>
            {excom
              ? t(`${i18nPath.homepage}.exCom.title`)
              : t(`${i18nPath.homepage}.corporate.title`)}
          </Heading2>

          {excom ? (
            <Body1>{t(`${i18nPath.homepage}.exCom.intro`)}</Body1>
          ) : (
            <Body1>{t(`${i18nPath.homepage}.corporate.intro`)}</Body1>
          )}
          <div className={styles.button}>
            {excom ? (
              <Button
                variant="secondary"
                onClick={() => goToPolicies('dk', 'en', 'excom')}
              >
                {t(`${i18nPath.dictionary}.knowMore`, 'Know more')}
              </Button>
            ) : (
              <Link to="/employees/employer/">
                <Button variant="secondary">
                  {t(`${i18nPath.dictionary}.knowMore`, 'Know more')}
                </Button>
              </Link>
            )}
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Homepage;
